import { FC } from 'react';

import CapitalEmptyImage from '../../assets/img/image_empty.svg';

import styles from './NoDataAvailableImage.module.scss';

type NoDataAvailableImageProps = { title?: string; description?: string };

const NoDataAvailableImage: FC<NoDataAvailableImageProps> = (props: NoDataAvailableImageProps): JSX.Element => {
  const { title, description } = props;

  return (
    <div className={styles.wrapper}>
      <img className={styles.noMessagesLogo} src={CapitalEmptyImage} alt="no data" />
      {title && <h4>{title}</h4>}
      {description && <span>{description}</span>}
    </div>
  );
};

export default NoDataAvailableImage;
